module.exports = __webpack_public_path__ + "static/media/speaker-present-live.7d674dc7.png";